import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, SadieVoicePostCall } from "@/types";

/** 04 on a finished simulated call. Nothing is written or sent. */
export function useRunSadieVoicePostCall() {
  return useMutation({
    mutationFn: async (request: { prompt: string; transcript: string }) => {
      const res = await guacHttpClient.post<
        SadieVoicePostCall,
        HttpResponse<SadieVoicePostCall>
      >("relationships/simulate/voice/post-call", request);
      return res.data;
    },
  });
}
